import type { FinancialKpis } from '../utils/financialCalculations';
import type { YearCashflow } from '../utils/financialCalculations';

function fmtNL(v: number, decimals = 0): string { return v.toLocaleString('nl-NL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); }
function fmtEur(v: number): string {
  if (Math.abs(v) >= 1e6) return `€${(v / 1e6).toLocaleString('nl-NL', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}M`;
  if (Math.abs(v) >= 1e3) return `€${(v / 1e3).toLocaleString('nl-NL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}k`;
  return `€${fmtNL(v)}`;
}

export default function Co2ImpactCard({ kpis, cashflows }: { kpis: FinancialKpis; cashflows?: YearCashflow[] }) {
  const projectDuration = kpis.projectDuration ?? 20;
  const ereYear1 = cashflows?.find(cf => cf.year === 1)?.ereRevenue ?? (kpis.co2CertificateValue / projectDuration);
  const ereTotal = kpis.co2CertificateValue;
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-1">🌱 CO₂-impact & Groencertificaten (ERE)</div>
      <div className="text-[9px] text-[#8899AA] mb-2">ERE = Energie-reductie Eenheden — vergoeding per geleverde kWh aan e-trucks (€/kWh). Berekening: geleverde MWh × ERE-tarief × jaarlijkse escalatie.</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="bg-[#F0FDF4] rounded-lg p-3 border border-[#BBF7D0]">
          <div className="text-[10px] text-[#166534] font-semibold mb-1">Totaal vermeden CO₂</div>
          <div className="text-lg font-bold text-[#166534]">{fmtNL(Math.round(kpis.totalCo2Avoided))} ton</div>
          <div className="text-[9px] text-[#8899AA] mt-1">Over {projectDuration} jaar</div>
        </div>
        <div className="bg-[#F0FDF4] rounded-lg p-3 border border-[#BBF7D0]">
          <div className="text-[10px] text-[#166534] font-semibold mb-1">Jaarlijks vermeden</div>
          <div className="text-lg font-bold text-[#166534]">{fmtNL(Math.round(kpis.totalCo2Avoided / projectDuration))} ton/j</div>
          <div className="text-[9px] text-[#8899AA] mt-1">Gemiddeld per jaar</div>
        </div>
        <div className="bg-[#EEF2FF] rounded-lg p-3 border border-[#C7D2FE]">
          <div className="text-[10px] text-[#4338CA] font-semibold mb-1">ERE-opbrengst jaar 1</div>
          <div className="text-lg font-bold text-[#4338CA]">{fmtEur(Math.round(ereYear1))}</div>
          <div className="text-[9px] text-[#8899AA] mt-1">Eerste jaar inkomsten</div>
        </div>
        <div className="bg-[#EEF2FF] rounded-lg p-3 border border-[#C7D2FE]">
          <div className="text-[10px] text-[#4338CA] font-semibold mb-1">ERE-opbrengst totaal</div>
          <div className="text-lg font-bold text-[#4338CA]">{fmtEur(Math.round(ereTotal))}</div>
          <div className="text-[9px] text-[#8899AA] mt-1">Cumulatief over {projectDuration} jaar</div>
        </div>
      </div>
    </div>
  );
}
